export const REWARDS_REFERRAL_SHARE_CHANNELS = {
    facebookShare: "facebookShare",
    twitterShare: "twitterShare",
    whatsAppShare: "whatsAppShare",
    facebookMessengerShare: "facebookMessengerShare",
    emailShare: "emailShare",
    pinterestShare: "pinterestShare",
} as const;

export const REWARDS_REFERRAL_SHARE_TOOLTIP = {
    [REWARDS_REFERRAL_SHARE_CHANNELS.facebookShare]: "facebook_tooltip",
    [REWARDS_REFERRAL_SHARE_CHANNELS.twitterShare]: "x_tooltip",
    [REWARDS_REFERRAL_SHARE_CHANNELS.whatsAppShare]: "whats_app_tooltip",
    [REWARDS_REFERRAL_SHARE_CHANNELS.facebookMessengerShare]:
        "messenger_tooltip",
    [REWARDS_REFERRAL_SHARE_CHANNELS.emailShare]: "email_tooltip",
    [REWARDS_REFERRAL_SHARE_CHANNELS.pinterestShare]: "pinterest_tooltip",
} as const;

export const REWARDS_REFERRAL_STATUS = {
    pending: "pending",
    completed: "completed",
} as const;
